import { render, staticRenderFns } from "./download_navigation.vue?vue&type=template&id=421e31ed&"
import script from "./download_navigation.vue?vue&type=script&lang=ts&"
export * from "./download_navigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports